const getScope = (state) => state.modules.auth.login;

export const getError = (state) => getScope(state).error;
export const getIsFetching = (state) => getScope(state).isFetching;

export const getShowTermsAcceptanceModal = (state) =>
  getScope(state).showTermsAcceptanceModal;

export const getIsTwoFactorRequired = (state) =>
  getScope(state).isTwoFactorRequired;
